/* eslint-disable no-template-curly-in-string */

import {
	GET_PEOPLE_TAGS_TABLE,
	getPeopleTagsTable,
	getUploadFileCSV,
	importUsersCSV,
	updateImage
} from 'api'
import {
	ActionToStepType,
	Button,
	StepOne,
	StepTwoCsvTag,
	StepTwoOrg,
	StepZero,
	TailwindModal,
	Typography
} from 'components'
import { useSearchDebounce, useToast } from 'hooks'
import {
	DocumentsInputs,
	DropdownFullItemProps,
	GenericModalProps,
	Images,
	PeopleMyTagsParentItem,
	Reach,
	TypographyTypes,
	UpdateImageResponse,
	UploadFileCSVBody
} from 'interfaces'
import React, { useEffect, useState } from 'react'
import { useInfiniteQuery } from 'react-query'
import Cookies from 'universal-cookie'
import { configGenaral } from 'utils'

export const ImportUsersModal: React.FC<GenericModalProps<string>> = ({
	open,
	setOpen
}) => {
	const cookies = new Cookies()
	const organizationId = cookies.get('organization_id')

	const initialStateTotalList = {
		tags: [],
		lists: [],
		dynamic_lists: [],
		individuals: [],
		organizations: [],
		feeds: [],
		partner_lists: [],
		organization_id: organizationId
	}
	const [totalList, setTotalList] = useState<Reach>(initialStateTotalList)

	const steps = [
		'Download template',
		'Setup user tags.',
		'Confirm import ',
		'We are Importing or Updating users!'
	]

	const [step, setStep] = useState<number>(0)
	const nextStep = step + 1
	const [fileUploaded, setFileUploaded] = useState<boolean>(false)
	const [fileSize, setFileSize] = useState(0)
	const [fileSizeUnit, setFileSizeUnit] = useState('')

	const [selectedTagOption, setSelectedTagOption] =
		useState<DropdownFullItemProps>({
			id: 0,
			name: '',
			value: ''
		})
	const [showCSVTagView, setShowCSVTagView] = useState(false)
	const [listTags, setListTags] = useState<PeopleMyTagsParentItem[]>([])
	const [selectedTags, setSelectedTags] = useState<PeopleMyTagsParentItem[]>([])
	const [documentUpload, setDocumentUpload] = useState<DocumentsInputs>()
	const { showToast } = useToast()
	const [loading, setLoading] = useState(false)
	const [csvUrl, setCsvUrl] = useState('')

	// Tags
	const {
		handleChangeDebounce: handleChangeDebounceTags,
		resetInput: resetInputTags
	} = useSearchDebounce('')
	const {
		data: dataTags,
		fetchNextPage: fetchNextPageTags,
		isFetchingNextPage: isFetchingNextPageTags,
		isLoading: isLoadingTags
	} = useInfiniteQuery(
		[GET_PEOPLE_TAGS_TABLE, organizationId],
		({ pageParam = 1 }) => getPeopleTagsTable(organizationId, pageParam, ''),
		{
			getPreviousPageParam: firstPage =>
				firstPage?.page ? firstPage.page : undefined,
			getNextPageParam: lastPage =>
				lastPage?.page ? lastPage.page + 1 : undefined
		}
	)

	useEffect(() => {
		if (dataTags) {
			setListTags(prevTags => {
				const newTags = dataTags.pages.flatMap(page => page?.items ?? [])
				return Array.from(
					new Set([...prevTags, ...newTags])
				) as PeopleMyTagsParentItem[]
			})
		}
	}, [dataTags])

	useEffect(() => {
		// Función auxiliar para buscar tags y subtags
		const findSelectedTags = (
			tags: PeopleMyTagsParentItem[],
			selectedIds: number[]
		): PeopleMyTagsParentItem[] => {
			const result: PeopleMyTagsParentItem[] = []

			tags.forEach(tag => {
				const selectedSubRows = tag?.subRows?.filter(subTag =>
					selectedIds.includes(subTag.organization_tag_id)
				)

				if (
					selectedIds.includes(tag.organization_tag_parent_id) ||
					(selectedSubRows?.length ?? 0) > 0
				) {
					const existingTag = result.find(
						t => t.organization_tag_parent_id === tag.organization_tag_parent_id
					)

					if (existingTag) {
						existingTag.subRows = [
							...(existingTag.subRows ?? []),
							...(selectedSubRows?.filter(subRow =>
								existingTag.subRows?.some(
									existingSubRow =>
										existingSubRow.organization_tag_id ===
										subRow.organization_tag_id
								)
							) ?? [])
						]
					} else {
						result.push({
							...tag,
							subRows: selectedIds.includes(tag.organization_tag_parent_id)
								? tag.subRows
								: selectedSubRows
						})
					}
				}
			})

			return result
		}

		const selectedTagsAux = findSelectedTags(listTags, totalList.tags)
		setSelectedTags(selectedTagsAux)
	}, [totalList, listTags])

	const formatFileSize = (sizeInMb: number): void => {
		let size: number
		let unit: string

		if (sizeInMb >= 1) {
			size = Number(sizeInMb.toFixed(2))
			unit = 'MB'
		} else if (sizeInMb >= 0.001) {
			size = Number((sizeInMb * 1024).toFixed(2))
			unit = 'KB'
		} else {
			size = Number((sizeInMb * 1024 * 1024).toFixed(2))
			unit = 'Bytes'
		}

		setFileSize(size)
		setFileSizeUnit(unit)
	}

	const handleUploadCSV = (file: File): void => {
		const fileSizeDoc = file.size
		const fileMb = fileSizeDoc / 1024 ** 2
		if (fileMb <= configGenaral.maxFileSizeMBImportUser) {
			formatFileSize(fileMb)
			const render = new FileReader()
			render.onload = e => {
				const uploadedObj = { file, url: e.target?.result as string }
				const uniqueId = new Date().getTime()
				const originalFileName = file.name
				const fileNameWithoutExtension = originalFileName
					.split('.')
					.slice(0, -1)
					.join('.')
				const fileExtension = originalFileName.split('.').pop()
				const uniqueFileName = `${fileNameWithoutExtension}_${uniqueId}.${fileExtension}`

				setDocumentUpload({
					description: '',
					title: uniqueFileName,
					size: fileSize,
					pdf: uploadedObj.url,
					name_file: uploadedObj.file.name
				})
				setFileUploaded(true)
			}
			render.readAsDataURL(file)
		} else {
			showToast(
				'Error',
				`Please select a file less than ${configGenaral.maxfileSizeMB}MB.`,
				'error'
			)
		}
	}

	const handleDeleteFile = (): void => {
		setFileUploaded(false)
		setDocumentUpload(undefined)
		const fileInput = document.getElementById('fileInput') as HTMLInputElement
		if (fileInput) {
			fileInput.value = ''
		}
	}

	const getURLDocument = async (
		credentials: UpdateImageResponse | null,
		file: string,
		name: string
	): Promise<string> => {
		if (!credentials) return ''
		const getFile = await fetch(file)
		const fileBlob = await getFile.blob()
		const newName = name.replaceAll('#', 'nro')
		const newKey = credentials.fields.key.replace('${filename}', newName)
		const body = {
			...credentials.fields,
			file: fileBlob,
			key: newKey
		}
		await updateImage(credentials.url, body)
		const url = `${credentials.url}${newKey}`
		return url
	}

	const uplpadCsvGetURL = async (): Promise<void> => {
		setLoading(true)
		const credentialsCSV = await getUploadFileCSV()
		if (documentUpload && documentUpload.pdf && credentialsCSV) {
			const documentName = `${documentUpload.title.replaceAll(' ', '')}`

			const url = await getURLDocument(
				credentialsCSV,
				documentUpload.pdf,
				documentName
			)
			if (url) {
				setCsvUrl(url)
				setStep(nextStep)
			}
		}
		setLoading(false)
	}

	const handleDisableStep = (): boolean => {
		if (step === 0) {
			return !fileUploaded
		}
		if (step === 1) {
			return !selectedTagOption
		}
		return false
	}

	const checkStepOne = (): boolean => {
		return (
			(selectedTagOption.id === 0 && step === 1) ||
			(step === 1 &&
				selectedTagOption.value === 'organization_tag' &&
				totalList.tags.length === 0)
		)
	}

	const actionStepTwo = async (): Promise<void> => {
		const body: UploadFileCSVBody = {
			url_file: csvUrl
		}

		if (selectedTags.length > 0) {
			body.organization_tag_ids = Array.from(
				new Set(
					selectedTags.flatMap(tag => {
						if (tag.subRows && tag.subRows.length > 0) {
							return tag.subRows.map(subTag => subTag.organization_tag_id)
						}
						return [tag.organization_tag_parent_id]
					})
				)
			)
		}

		setStep(nextStep)
		await importUsersCSV(organizationId, body)
	}

	const actionToStep: ActionToStepType = {
		0: async () => {
			await uplpadCsvGetURL()
		},
		1: {
			csv_tag: () => {
				setStep(2)
				setShowCSVTagView(true)
			}
		},
		2: async () => {
			await actionStepTwo()
		},
		3: () => setStep(nextStep)
	}

	const handleClick = async (): Promise<void> => {
		const action = actionToStep[step]

		if (typeof action === 'function') {
			await action()
		} else if (typeof action === 'object' && action.csv_tag) {
			action.csv_tag()
		}
	}

	const hasButtonPrev = step === 2 && selectedTagOption.value !== ''
	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			titleClassName="font-bold text-[24px] leading-[28px]"
			className="w-[700px] h-auto p-4 rounded-[16px]"
			showCloseButton
		>
			<div className="flex flex-col h-[95%]">
				<div className="flex-grow px-7">
					<div className="flex flex-col items-center gap-2 pt-6 w-full">
						<div className="flex flex-col gap-2 w-full">
							<Typography
								className="text-[24px] leading-[28px] text-gray-14 font-semibold"
								type={TypographyTypes.h3}
								fontLeading="14/24"
								title="Import or Update Users"
							/>
							<div className="flex justify-between">
								{steps.map((_, index) => (
									<div key={index} className="flex-1 mx-1">
										<div
											className={`h-1 ${
												index <= step ? 'bg-blue-primary' : 'bg-gray-200'
											}`}
										/>
									</div>
								))}
							</div>
							<div className="flex flex-start items-center w-full">
								<Typography
									title={`Step ${nextStep} of ${steps.length}`}
									fontLeading="14/24"
									type={TypographyTypes.p}
									className="text-black-1 font-normal text-medium"
								/>
							</div>
						</div>

						{step === 0 && (
							<StepZero
								fileUploaded={fileUploaded}
								handleUploadCSV={handleUploadCSV}
								steps={steps[0]}
								documentUpload={documentUpload}
								fileSize={fileSize}
								fileSizeUnit={fileSizeUnit}
								handleDeleteFile={handleDeleteFile}
							/>
						)}
						{step === 1 && (
							<StepOne
								selectedTagOption={selectedTagOption}
								steps={steps[1]}
								initialStateTotalList={initialStateTotalList}
								dataTags={dataTags}
								isLoadingTags={isLoadingTags}
								totalList={totalList}
								isFetchingNextPageTags={isFetchingNextPageTags}
								handleChangeDebounceTags={handleChangeDebounceTags}
								resetInputTags={resetInputTags}
								fetchNextPageTags={fetchNextPageTags}
								setSelectedTagOption={setSelectedTagOption}
								setTotalList={setTotalList}
							/>
						)}
						{showCSVTagView &&
							selectedTagOption.value === 'csv_tag' &&
							step === 2 && (
								<StepTwoCsvTag
									fileUploaded={fileUploaded}
									steps={steps[1]}
									documentUpload={documentUpload}
									fileSize={fileSize}
									fileSizeUnit={fileSizeUnit}
								/>
							)}
						{step === 2 && selectedTagOption.value === 'organization_tag' && (
							<StepTwoOrg
								fileUploaded={fileUploaded}
								selectedTags={selectedTags}
								steps={steps[2]}
								documentUpload={documentUpload}
								fileSize={fileSize}
								fileSizeUnit={fileSizeUnit}
							/>
						)}
						{step === 3 && (
							<div className="flex flex-col justify-start w-full items-start gap-4">
								<Typography
									title={steps[3]}
									fontLeading="14/24"
									type={TypographyTypes.h1}
									className="text-black font-medium text-lg"
								/>
								<Typography
									title="Thank you for uploading your data. We’ll notify you via email once the process is complete."
									fontLeading="14/24"
									type={TypographyTypes.p}
									className="text-black font-normal text-base"
								/>
								<div className="flex justify-center items-center w-full">
									<img
										src={Images.userImport}
										className="w-[22rem] h-[17.7rem] mx-auto"
										alt="user_import"
									/>
								</div>
							</div>
						)}
					</div>
				</div>
				{step < 3 ? (
					<div className="w-full flex flex-col sm:flex-row justify-center gap-4 py-4">
						<Button
							label={hasButtonPrev ? 'Previous' : 'Close'}
							className="!min-w-[8rem]"
							color="Transparent"
							onClick={() => {
								if (hasButtonPrev) {
									setStep(prevStep => prevStep - 1)
								} else {
									setOpen(false)
								}
							}}
						/>
						<Button
							label={
								loading
									? 'Loading...'
									: step === 2
									? 'Confirm and import'
									: 'Continue'
							}
							className="!min-w-[8rem]"
							color="Primary"
							onClick={handleClick}
							disabled={handleDisableStep() || loading || checkStepOne()}
						/>
					</div>
				) : (
					<div className="w-full flex items-center justify-center pt-4">
						<Button
							label="Ok, Back to My People"
							className="!min-w-[12.5rem]"
							color="Primary"
							onClick={() => setOpen(false)}
						/>
					</div>
				)}
			</div>
		</TailwindModal>
	)
}
